import { graphql } from "@/gql";

export const blogPostTripArticleListQuery = graphql(`
  query BlogPostTripArticleListQuery(
    $originCityId: ID!
    $destinationCityId: ID!
  ) {
    blogPostTripArticles(
      originCityId: $originCityId
      destinationCityId: $destinationCityId
    ) {
      id
      blog_post_id
      blogPost {
        id
        slug
        title
        hero_image {
          ...MediaFields
        }
      }
      sort_order
      created_at
    }
  }
`);

export const createBlogPostTripArticleMutation = graphql(`
  mutation CreateBlogPostTripArticleMutation(
    $input: CreateBlogPostTripArticle!
  ) {
    createBlogPostTripArticle(input: $input) {
      id
    }
  }
`);

export const deleteBlogPostTripArticleMutation = graphql(`
  mutation DeleteBlogPostTripArticleMutation($id: ID!) {
    deleteBlogPostTripArticle(id: $id) {
      id
    }
  }
`);

export const sortBlogPostTripArticleMutation = graphql(`
  mutation SortBlogPostTripArticleMutation($ids: [ID!]!) {
    setBlogPostTripArticleSortOrder(ids: $ids)
  }
`);
